import React from 'react'
import classNames from 'classnames'
import './NewActionHeader.less'
import { Box } from 'front-end/src/components'
import { css } from '@emotion/react'
import { useLooopTheme } from '../../../../public-api/hooks/useLooopTheme'
import { NbSp } from 'front-end/src/utils/NbSp'

interface IProps {
  steps: Record<string, any>
  title?: string | JSX.Element
  prevButton?: any
  nextButton?: any
  currentStep: string
}

const NewActionHeader = (props: IProps) => {
  const { theme } = useLooopTheme()
  const { steps, title, prevButton, nextButton, currentStep } = props

  return (
    <Box
      as="header"
      className="NewActionHeader"
      css={css`
        ul {
          li {
            &.completed:before {
              border-color: ${theme.colors.buttonPrimary.default};
            }
            &.current:before {
              background: ${theme.colors.buttonPrimary.default};
              border-color: ${theme.colors.buttonPrimary.default};
            }
            & + li.current:after,
            & + li.completed:after {
              background: ${theme.colors.buttonPrimary.default};
            }
          }
        }
      `}
    >
      {title ? <h3>{title}</h3> : null}
      <ul>
        {Object.values(steps).map((step, index) => {
          return (
            <li
              key={index}
              className={classNames({
                current: currentStep === step,
                completed: index <= Object.values(steps).indexOf(currentStep)
              })}
            >
              {step}
            </li>
          )
        })}
      </ul>
      <div className="NewActionHeader__buttons">
        {prevButton}
        <NbSp />
        {nextButton}
      </div>
    </Box>
  )
}

export default NewActionHeader
